import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild,ElementRef } from '@angular/core';
import {MatAccordion} from '@angular/material/expansion';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { ServiceService } from 'src/app/servicios/service.service';
import {PeticionesService} from '../servicios/httpservice';
import { Calendar, CalendarOptions } from '@fullcalendar/core';

import dayGridPlugin from '@fullcalendar/daygrid'; 


/* import { SocketServiceService } from 'src/app/servicios/socket-service.service';  */
import Swal from 'sweetalert2';
import { isNull } from '@angular/compiler/src/output/output_ast';
declare var $: any;
@Component({
  selector: 'app-leads-cartera',
  templateUrl: './leads-cartera.component.html',
  styleUrls: ['./leads-cartera.component.css']
})
export class LeadsCarteraComponent implements OnInit {
  panelOpenState = false; public emailEsObligatorio: any; public emailEsValido: any; public banderaCards: any = true; public banderaLista: any; public banderaCalendario: any; public calendarioLeads: any = []
  @ViewChild('summernote', { static: true }) summernote: any; activeButton: string = 'cards'; public ListadoHistorial: any = []; public arrayPresentacion: any = []; public arrayRecorridoLead: any = []; public arrayRecorridoProspecto: any = []; public arrayPropuesta: any = []; public arrayNegociacion: any = []; public arrayCierre: any = []; public arrayPropuestaCliente: any = []; public arrayNegociacionCliente: any = []; public arrayCierreCliente: any = []; public strZona: any; public array_por_contactar: any = []; public arrayAgentes: any = []; public intTotal_por_contactar: any = 0; public intTotal_presentacion: any = 0; public intTotal_recorrido_lead: any = 0; public intTotal_recorrido_prospecto: any = 0; public intTotal_propuesta: any = 0; public intTotal_negociacion: any = 0; public intTotal_cierre: any = 0; public intTotal_Perdido: any = 0; public intTotal_propuesta_cliente: any = 0; public intTotal_negociacion_cliente: any = 0; public intTotal_cierre_cliente: any = 0; public strTipo: any = 'lead'; public strAgente: any = ''; public strAgenteSP: any; public strAgenteAsignado: any; public strInicialesAgente: any = ''; public strFechaActividadUltima: any; public strFechaPerdido: any; public dblMontoPorContactar: any; public dblMontoPresentacion: any; public dblMontoRecorridoLead: any; public dblMontoRecorridoProspecto: any; public dblMontoPropuesta: any; public dblMontoNegociacion: any; public dblMontoCierre: any; public dblMontoPropuestaCliente: any; public dblMontoNegociacionCliente: any; public dblMontoCierreCliente: any; public diferenciaDias: any; public diferenciaHoras: any; public diferenciaMinutos: any; public strActividadSimple: any = ''; public strTipoCotizacion: any = ''; public arrayAnexosUpdate: any = []; public strMotivoCancelado: any; public strMotivoPerdido: any; public strFechaActividad: any; public intDuracionActividad: any = 0; public strComentario: any; public strResultado: any; public strTipoActividad: any = ''; public strEstatus: any; public strDescripcionActividad: any; public intTiempoDias: any = 0; public intTiempoHoras: any = 0; public banderaCierre: any = true; public banderaFuturo: any = false; public guardarHabilitado: any = true; public strCoordinadorOperativo: any; public strNombreEmpresa: any; public strEtapa: any = 'Por Contactar'; public strSector: any = ''; public intGiro: any = ''; public strFamilia: any = ''; public strMedioConocio: any = ''; public dblImporte: any = ''; public strProbabilidad: any = ''; public strFechaEstimadaCierre: any = ''; public strFechaEstimadaCierreInput: any = ''; public strFechaCancelado: any; public strNumeroEmpleados: any = ''; public intTotalSucursales: any = ''; public strRazonSocial: any = ''; public strSitioWeb: any = ''; public strRFC: any = ''; public strNombreContacto: any = ''; public strPuestoContacto: any = ''; public strTelefonoContacto: string = ''; public strEmailContacto: any = ''; public strUrl: any = ''; public strCodigoPostal: any; public strCalle: any = ''; public strEstado: any = ''; public strNumeroExterior: any = ''; public strDelegacion: any = ''; public strEntreCalles: any = ''; public strColonia: any = ''; public strLadaEmpresa: any = ''; public strTelefonoEmpresa: any = ''; public strOtraColonia: any = ''; public strTipoAnexo: any = 'Contrato'; public arrayAnexos: any = []; public banderaColonia: any = false; public banderaTipo: any = true; public arrayGiros: any = []; public arrayTamanoEmpresa: any = []; public arrayColonias: any = []; public ListaAnexos: any = []; public minDate: any = ''; public strPrioridad: any; public strTipoAgente: any; public filterPost: any; public arrayTotalLeads: any; public intIDLeads: any; public strFase: any; public banderaFase: any; public arrayZonas: any; public opcionSeleccionada: string = 'espera'; public fechaActual: any; public arrayActividades: any = []; public global: any; public subcadena = ","; public fechaInicioServicio: any = null; public strComentarioCancelado: any; public strComentarioPerdido: any; public strFechaInicioServicio: any; public intCantidadElementos: any = 0; public arrayFamilias: any = []; public datosFiltradosContactar: any = []; public datosFiltradosPresentacion: any = []; public datosFiltradosRecorrido: any = []; public filtroFecha: string = ''; public datosFiltradosPropuesta: any = []; public datosFiltradosNegociacion: any = []; public datosFiltradosCierre: any = []; public datosFiltradosPropuestaCliente: any = []; public datosFiltradosNegociacionCliente: any = []; public datosFiltradosCierreCliente: any = []; public datosFiltradosPerdidos: any; public arrayPerdidos: any = []; public dblMontoPerdidos: any; public intIDAnexo: any; public arrayContactos: any; public arrayContactosDetalle: any = []; public banderaEspera: any = true; public banderaGanado: any = false; public banderaCancelado: any = false; public banderaPerdido: any = false; public strRecomendacion: any; public selectedItem: any; public banderaContacto: any; public elementosPorClic: any = 3; public elementosPorPaginaPorContactar: any; public elementosPresentacion: any; public elementosRecorrido: any; public elementosPerdido: any; public elementosPEProspecto: any; public elementosNProspecto: any; public elementosCProspecto: any; public elementosPECliente: any; public elementosNCliente: any; public elementosCCliente: any; public esDispositivoPequeno: any; public intIDPeritaje: any; public arrayLisFamilia: any; public intIDUbicacion: any; public intIDCliente: any
  public calendarOptions: any; @ViewChild('calendar', { static: true }) calendar: any;
  opciones = [
    { valor: 'llamada', icono: 'fas fa-phone-alt' },
    { valor: 'correo', icono: 'fas fa-envelope' },
    { valor: 'visita', icono: 'fas fa-walking' },
  ];
  arrayAccesos:any;
  arrayFiltros:any={lstDivicionales:false,lstSucursales:false,lstAgentes:false};
  arrayDivicionales:any;
  arrayAgentess:any = [];
  arraySucursales:any = [];
  arrayPedidos:any= [];
  strGerenteDiv:string="";
  strSucursal:string="";
  strAgentee:string="";
  public arrayContacto: any
  checkboxes: any = {
    hoy: false,
    manana: false,
    estaSemana: false,
    esteMes: false,
    futuros: false,
    conDemora: false,
  };

  public contenido: string = '';
  public strTextButton :string= 'seleccione Archivo'
  public strAsunto: string = '';
  public file: File;
  public strDestinatario:string;
  public strRemitente:string;
  @ViewChild('fileInput') fileInput: ElementRef;

  constructor(public router: Router, public _serviciosService: ServiceService,private _httpService:PeticionesService, public route: ActivatedRoute, private cdr: ChangeDetectorRef, public localSt: LocalStorageService) {/*, public socket: SocketServiceService */
    $('[data-toggle="popover"]').popover({
      html: true
    });

    this.esDispositivoPequeno = this.isMobile();
    // Obtener la fecha y hora actual
    const fechaActual = new Date();

    // Formatear la fecha y hora en el formato adecuado para el campo de entrada
    this.fechaActual = fechaActual.toISOString().slice(0, 16);

    //let agente = (this.localSt.retrieve('strPersonal')).split(' ')
    this.strAgenteSP = "012" //this.localSt.retrieve('strAgente')
    this.strTipoAgente ="selene.estrada@ecodeli.com"// this.localSt.retrieve('strEmail')

    const fecha = new Date();
    this.strFechaEstimadaCierreInput = this.formatoFecha(fecha);
    this.emailEsObligatorio = false
    this.fnListadoFamilias()

    this.arrayContactosDetalle = [{
      strNombreContacto: '',
      strContactoPuesto: '',
      strContactoTelefono: '',
      strContactoEmail: '',
      emailEsObligatorio: false
    }]
  }

  fnGetDivisionales(){
    this.strGerenteDiv = this.arrayFiltros.lstSucursales && !this.arrayFiltros.lstDivisionales  ?this.arrayAccesos[0].strUsuario:"";
    this.strSucursal = this.arrayFiltros.lstAgentes && !this.arrayFiltros.lstSucursales ? this.arrayAccesos[0].sucursal:"";
    this.strAgentee = !this.arrayFiltros.lstAgentes?this.arrayAccesos[0].strAgente :"";
    if(this.strAgentee != ""){
console.log("");
    }else if(this.strSucursal != ""){  // si es gerente de sucursal extrae los agentes
      this.fnSelect("Agente");
    }else if(this.strGerenteDiv != ""){// si es gerente divicional extrae las sucursales
      this.fnSelect("Sucursal");
    } else  if(this.arrayFiltros.lstDivisionales){
      this._httpService.getEcodeli({},'getDivisionales').subscribe(
        result => { 
          this.arrayDivicionales = result;
          console.log(this.arrayDivicionales)
          this.strAgentee = '';
          this.strSucursal = '';

        });
       
      }  
 }
 fnGetSucursales(){
  this._httpService.getEcodeli({strGerente:this.strGerenteDiv},'getSucursales').subscribe(
    result => { 
      this.arraySucursales = result; 

      let objSucTodo ={ strSucursal:'',strNombre:'--Todas---',strGerente:this.arraySucursales[0].strGerente};

      this.arraySucursales.push(objSucTodo);
      this.strAgentee = '';

      //this.strSucursal= this.arraySucursales[0].strSucursal;//this.arrayAccesos[0].sucursal;
     this.fnGetAgentes();
       this.strSucursal = '';
     // this.fnMostrarPedidos();
      console.log(this.arraySucursales)
    });
   
 }
 fnGetAgentes(){
  this._httpService.getEcodeli({strGerente:this.strGerenteDiv,strSucursal:this.strSucursal},'getAgentes').subscribe(
    result => { 
      this.arrayAgentess = result;
      let objSucTodo ={strAgente:'',strSucursal:'',strNombre:'--Todos---'};
      this.arrayAgentess.push(objSucTodo);
      this.strAgentee = '';
      console.log(this.arrayAgentess)
    });
    
 }
 fnSelect(strAccion:string){
  if(strAccion == 'Sucursal'){
    this.fnGetSucursales();
  }else if(strAccion == 'Agente'){
    this.fnGetAgentes();
  }
 }
  getInitials(name: string): string {
    const names = name.split(' ');
    const initials = names.slice(0, 2).map(n => n.charAt(0).toUpperCase());
    return initials.join('');
  }

  isMobile() {
    return window.innerWidth <= 768; // Puedes ajustar el valor 768 según tus necesidades.
  }

  // Escucha los eventos de cambio de tamaño de la ventana para actualizar la variable esDispositivoPequeno.
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {

    this.esDispositivoPequeno = this.isMobile();

    if (this.esDispositivoPequeno) {
      this.elementosPorPaginaPorContactar = 3
      this.elementosPresentacion = 3
      this.elementosRecorrido = 3
      this.elementosPEProspecto = 3
      this.elementosNProspecto = 3
      this.elementosCProspecto = 3
      this.elementosNCliente = 3
      this.elementosNCliente = 3
      this.elementosCCliente = 3
    } else {
      this.elementosPorPaginaPorContactar = this.array_por_contactar.length
      this.elementosPresentacion = this.arrayPresentacion.length
      this.elementosRecorrido = this.arrayRecorridoLead.length
      this.elementosPEProspecto = this.datosFiltradosPropuesta.length
      this.elementosNProspecto = this.datosFiltradosNegociacion.length
      this.elementosCProspecto = this.datosFiltradosCierre.length
      this.elementosPECliente = this.datosFiltradosPropuestaCliente.length
      this.elementosNCliente = this.datosFiltradosNegociacionCliente.length
      this.elementosCCliente = this.datosFiltradosCierreCliente.length
    }
  }

  mostrarMas(fase: any) {
    if (fase == 'porContactar') {
      this.elementosPorPaginaPorContactar += this.elementosPorClic;
    } else if (fase == 'presentacion') {
      this.elementosPresentacion += this.elementosPorClic;
    } else if (fase == 'recorrido') {
      this.elementosRecorrido += this.elementosPorClic;
    } else if (fase == 'perdido') {
      this.elementosPerdido += this.elementosPorClic;
    } else if (fase == 'propuestaProspecto') {
      this.elementosPEProspecto += this.elementosPorClic
    } else if (fase == 'negociacionProspecto') {
      this.elementosNProspecto += this.elementosPorClic
    } else if (fase == 'cierreProspecto') {
      this.elementosCProspecto += this.elementosPorClic
    } else if (fase == 'propuestaCliente') {
      this.elementosPECliente += this.elementosPorClic
    } else if (fase == 'negociacionCliente') {
      this.elementosNCliente += this.elementosPorClic
    } else if (fase == 'cierreCliente') {
      this.elementosCCliente += this.elementosPorClic
    }
  }

  ngAfterViewInit() {
    $(this.summernote.nativeElement).summernote(
      {
        callbacks: {
          onChange: (contents) => {
            this.contenido = contents;
          },
        },
      }
    );
    $('span.note-icon-caret').remove();
    $('.note-editable').css('background', '#fff');
  }
  fnAsignarDatos(){

    this.arrayAccesos=this.localSt.retrieve('arrayAccesos')?this.localSt.retrieve('arrayAccesos'):[];
    this.arrayAccesos = this.arrayAccesos.filter(o => o.strComponente === 'app-pedidos-ventas');
    this.arrayFiltros.lstDivisionales = this.arrayAccesos.filter(o => o.strAccion === 'lstDivisionales').length > 0 ? true:false;
    this.arrayFiltros.lstSucursales = this.arrayAccesos.filter(o => o.strAccion === 'lstSucursales').length > 0 ? true:false;
    this.arrayFiltros.lstAgentes = this.arrayAccesos.filter(o => o.strAccion === 'lstAgentes').length > 0 ? true:false;
    console.log(this.arrayAccesos);
  }
  selectFile() {
    // Simula un clic en el input de tipo archivo
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: any) {
    // Obtiene el nombre del archivo seleccionado y lo muestra en el botón
    this.file = event.target.files[0];
    if ( this.file) {
      this.strTextButton =  this.file.name;
    } else {
      this.strTextButton = 'Seleccionar archivo';
    }
  }
  fnEnviarCOrreo(){
    let rest:any,cuerpo:string,asunto:string,destinatario:string,remitente:string,correoValido:boolean;
    destinatario = this.strDestinatario;
    remitente = this.strRemitente;
    cuerpo = this.contenido;
    asunto = this.strAsunto;

    const regexCorreo = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    correoValido = regexCorreo.test(destinatario);
 
    if(correoValido){
      
      if(asunto == "" || asunto == null){
        Swal.fire({
          title: 'Confirmación',
          text: "¿Está seguro de enviar el correo sin asunto?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, Enviar'
        }).then((result) => {
          if (result.isConfirmed) {
            this._httpService.getObjCorreo(cuerpo,asunto,this.file,destinatario,remitente).subscribe(
              result =>{
                rest= result;
                if(rest.success){
                  Swal.fire('Correo Enviado Correctamente','','success');
                  this.fnLimpiarCorreo();
                }else{
                  Swal.fire('Error al enviar correo','','error');
                }
                console.log(rest);
              }
            );
          }
        })
      }else{
        this._httpService.getObjCorreo(cuerpo,asunto,this.file,destinatario,remitente).subscribe(
          result =>{
            rest= result;
            if(rest.success){
              Swal.fire('Correo Enviado Correctamente','','success');
              this.fnLimpiarCorreo();
            }else{
              Swal.fire('Error al enviar correo','','error');
            }
            console.log(rest);
          }
        );
      }
    }else{
      Swal.fire('Error','Correo de destino invalido, favor de verificarlo!','error');
    }
  }


  fnLimpiarCorreo(){
    this.strDestinatario = "";
    this.strAsunto = "";
    $(this.summernote.nativeElement).summernote('code', ''); 
  }




  cambiarBanderaColonia(event: any) {
    if (event.target.value == 'otraColonia') {
      this.banderaColonia = true
    } else {
      this.banderaColonia = false
    }
  }
  cambiarEstatusAnexo(event: any) {
    var f = new Date();
    this.strTipoAnexo = event.target.value
    this.strUrl = 'Leads/' + event.target.value + ' ' + f.getDate()
    this.banderaTipo = false
  }


  formatoFecha(fecha: Date): string {
    // Formatear la fecha en el formato deseado (ejemplo: "yyyy-MM-dd")
    const year = fecha.getFullYear();
    const month = ('0' + (fecha.getMonth() + 1)).slice(-2);
    const day = ('0' + fecha.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  mostrarDivInfo() {
    var divInfo = document.getElementById("divInformacion");
    divInfo?.classList.toggle("mostrar");
  }

  stopPropagation(event: any, estado: any) {

    event.stopPropagation();

    if (estado == 'Ganado') {
      this.banderaGanado = true
      this.banderaEspera = false
      this.banderaCancelado = false
      this.banderaPerdido = false
    } else if (estado == 'Espera') {
      this.banderaEspera = true
      this.banderaGanado = false
      this.banderaCancelado = false
      this.banderaPerdido = false
    } else if (estado == 'perdido') {
      this.banderaEspera = false
      this.banderaGanado = false
      this.banderaCancelado = false
      this.banderaPerdido = true
    } else {
      this.banderaEspera = false
      this.banderaGanado = false
      this.banderaCancelado = true
      this.banderaPerdido = false
    }
  }

  stopPropagation2(event: any) {
    event.stopPropagation();
  }

  playPropagacion(event: Event) {
    event.preventDefault();
  }

  ngOnInit(): void {
    this.strRemitente= this.localSt.retrieve('strEmail');
    this.route.queryParams.subscribe((params: any) => {
      if (params.tipo) {
        this.strTipo = params.tipo
      } else {
        this.strTipo = 'lead'
      }
      this.fnListadoLeads()
      this.fnListadoAgente()
      this.fnGiros()
      this.fnTamanoEmpresa()
      this.fnZonas()
      this.fnAsignarDatos();
     this.fnGetDivisionales()
    });
  }

  agregarAnexo(event: any) {
    this.arrayAnexosUpdate = []
    const fecha = new Date();
    const archivo: File = event.target.files[0];
    const tipo = archivo.type.split('/');
    if (tipo[1] == "vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      tipo[1] = "xlsx";
    }
    const nombreArchivo = this.strTipoAnexo + ' ' + fecha.getFullYear() + '-' + fecha.getMonth() + '-' + fecha.getDay() + ' ' + fecha.getHours() + ':' + fecha.getMinutes() + ':' + fecha.getSeconds() + '.' + tipo[1];
    const rutaArchivo = 'EvidenciasAnexos/' + nombreArchivo;
    const nuevoArchivo = new File([archivo], nombreArchivo, { type: archivo.type });
    this.ListaAnexos.push(nuevoArchivo);
    this.arrayAnexosUpdate.push({
      strTipo: tipo[1],
      strNombre: nombreArchivo,
      strUrl: rutaArchivo
    });
  }

  fnDetalleLead(id: any) {
    this.arrayAnexosUpdate = []
    this._serviciosService.sp_Leads({
      strAccion: 'DetalleLeads',
      intIdLeads: id
    }).subscribe((data: any) => {

      if (data.length > 0) {

        if (data[0].fechaCierre_Estimada) {
          let fechaCierre = data[0].fechaCierre_Estimada.split(' ')
          let fecha = fechaCierre[0].split('/')
          this.strFechaEstimadaCierre = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
        }

        this.intIDLeads = data[0].intIdLeads
        this.strNombreEmpresa = data[0].strNombreEmpresa
        this.strEtapa = data[0].strEstatus

        if (this.strEtapa == 'Por Contactar' || this.strEtapa == 'Presentacion' || this.strEtapa == 'Recorrido') {
          this.banderaFase = true
        } else if (this.strEtapa == 'Propuesta Economica' || this.strEtapa == 'Negociacion' || this.strEtapa == 'Cierre') {
          this.banderaFase = false
        }

        if (data[0].strFechaInicioServicio) {
          let fechaInicio = data[0].strFechaInicioServicio.split(' ')
          let fa = fechaInicio[0].split('/')
          let f = fa[2] + '-' + fa[1] + '-' + fa[0]
          this.strFechaInicioServicio = f

          this.opcionSeleccionada = 'ganado';

          this.banderaGanado = true
          this.banderaEspera = false
          this.banderaCancelado = false
          this.banderaPerdido = false

        } else {
          this.opcionSeleccionada = 'espera';

          this.banderaEspera = true
          this.banderaGanado = false
          this.banderaCancelado = false
          this.banderaPerdido = false
        }

        this.intIDCliente = data[0].intIDCliente
        this.intIDPeritaje = data[0].intIDPeritaje
        this.strSector = data[0].strSector
        this.intGiro = data[0].intID_Giro
        this.strMedioConocio = data[0].strMedioNosConocio
        this.dblImporte = data[0].dblMonto
        this.strProbabilidad = ''
        this.strNumeroEmpleados = data[0].strNoEmpleados

        if (this.strNumeroEmpleados == '1-20 empleados') {
          this.strPrioridad = 'Baja'
        } else if (this.strNumeroEmpleados == '21-50 empleados' || this.strNumeroEmpleados == '51 - 300 empleados') {
          this.strPrioridad = 'Media'
        } else if (this.strNumeroEmpleados == '3001 - 1000 empleados') {
          this.strPrioridad = 'Alta'
        } else if (this.strNumeroEmpleados == '1001 - 2000 empleados' || this.strNumeroEmpleados == '2001 + empleados') {
          this.strPrioridad = 'URGENTE'
        }

        this.intIDUbicacion = data[0].intIDUbicacion
        this.intTotalSucursales = data[0].intNoSucursales
        this.strRazonSocial = data[0].strRazonSocial
        this.strSitioWeb = data[0].strSitioWeb
        this.strRFC = data[0].strRFC
        this.strNombreContacto = data[0].strNombreContacto
        this.strPuestoContacto = data[0].strContactoPuesto
        this.strTelefonoContacto = data[0].strContactoTelefono
        this.strEmailContacto = data[0].strContactoEmail
        this.strCodigoPostal = data[0].strCodigoPostal
        this.strCalle = data[0].strCalle
        this.strEstado = data[0].strEstado
        this.strNumeroExterior = data[0].intNoExterior
        this.strDelegacion = data[0].strDelegacion
        this.strEntreCalles = data[0].strEntreCalles
        this.strColonia = data[0].strColonia
        this.strLadaEmpresa = data[0].intLada
        this.strTelefonoEmpresa = data[0].intTelefono
        this.strPrioridad = data[0].strPrioridad
        this.strRecomendacion = data[0].strRecomendado
        this.strAgente = data[0].strAgente
        this.strFase = data[0].strFase
        this.intCantidadElementos = data[0].intNumeroEmpleados
        this.strTipoCotizacion = data[0].strTipoCotizacion
        this.strCoordinadorOperativo = data[0].strCoordinadorOperativo

        if ((this.strNombreContacto || this.strPuestoContacto || this.strTelefonoContacto) && this.strEmailContacto != '') {
          this.emailEsObligatorio = true
          if (this.emailEsObligatorio && this.validarEmail(this.strEmailContacto)) {
            this.emailEsObligatorio = false
          }
        }
        this.fnGetContactos()
        this.fnGetAnexos()
        this.fnGetActividadPendiente()
        this.fnGetActividades()
      } else {
        console.log('Sin datos')
      }
      document.getElementById('modalDetalle')?.click();
    },
      error => {
        var error = <any>error;
        console.log(error);
      }
    )
  }

  validarUbicacion() {

    if (this.strEtapa == 'Recorrido') {

      if (!this.strCodigoPostal) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'No se tiene con una ubicación registrada, Favor de agregar los datos fiscales!',
        })
      } else {
        //this.fnValidacion_Ubicacion()
      }
    }
  }

  fnValidacion_Ubicacion() {
    this._serviciosService.sp_Leads({
      strAccion: 'Insert_Ubicacion_Cte',
      strRFC: this.strRFC,
      intIdLeads: this.intIDLeads,
      strNombreEmpresa: this.strNombreEmpresa,
      intID_Giro: parseInt(this.intGiro),
      strEstado: this.strEstado,
      strCalle: this.strCalle,
      intNoExterior: this.strNumeroExterior,
      strDelegacion: this.strDelegacion,
      strCodigoPostal: this.strCodigoPostal,
      strColonia: this.strColonia
    }).subscribe((data: any) => {

    },
      error => {
        var error = <any>error;
        console.log(error);
      }
    )
  }

  fnGetContactos() {

    this._serviciosService.sp_Leads({
      strAccion: 'DetalleContactos',
      intIdLeads: this.intIDLeads
    }).subscribe((data: any) => {

      this.arrayContactosDetalle = data
    },
      error => {
        var error = <any>error;
        console.log(error);
      }
    )
  }

  fnListadoAgente() {
    this._serviciosService.sp_Leads({
      strAccion: 'ListadoAgente',
    }).subscribe((data: any) => {

      this.arrayAgentes = data
    },
      error => {
        var error = <any>error;
        console.log(error);
      }
    )
  }

  fnBorrarAnexo(intIDAnexo: any) {


    Swal.fire({
      title: 'Estas seguro de borrar el anexo?',

      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, Borrarlo!'
    }).then((result) => {
      if (result.isConfirmed) {
        this._serviciosService.sp_Leads({
          strAccion: 'BORRAR_ANEXO',
          intIDLeads: intIDAnexo
        }).subscribe((data: any) => {

          this.fnGetAnexos()
        },
          error => {
            var error = <any>error;
            console.log(error);
          }
        )
        Swal.fire(
          'Borrado!',
          'Anexo Eliminado.',
          'success'
        )
      }
    })
  }

  fnListadoFamilias() {
    this.arrayLisFamilia = []
    this._serviciosService.getDefaultRH({
      strAccion: 'LISTA_FAMILIA',
    }).subscribe((data: any) => {

      this.arrayFamilias = data
      this.arrayFamilias.forEach((element: any) => {
        let aux = this.arrayLisFamilia.filter((b: any) => b.strTipo == element.strTipo)
        if (aux.length == 0 && element.strTipo != '') {
          this.arrayLisFamilia.push({ "strTipo": element.strTipo })
        }
      });
    },
      error => {
        var error = <any>error;
        console.log(error);
      }
    )
  }

  fnInsertAnexos() {
    this._serviciosService.sp_Leads({
      strAccion: 'INSERT_ANEXOS',
      intIDLeads: this.intIDLeads,
      xlmAnexos: this.arrayAnexosUpdate
    }).subscribe((data: any) => {

    },
      error => {
        var error = <any>error;
        console.log(error);
      }
    )
  }

  SubirAnexos() {

    if (this.ListaAnexos.length > 0) {
      this._serviciosService.makeFileRequest('https://ecodeli-industrial.com/PaginaIndustrial/SubirEvidenciaAnexo.php', [], this.ListaAnexos).then((result) => {

        // this.resultUpload=result;
        Swal.fire({
          icon: 'success',
          title: 'Correcto...',
          text: 'Anexos Guardados',
        });
        this.fnInsertAnexos()
      }, (error) => {
        console.log(error);
      });
    } else {
      this.fnInsertAnexos()
    }
  }

  fnListadoLeads() {
    this.calendarioLeads = []
    this._serviciosService.sp_Leads({
      strAccion: 'Leads_PorContestar',
      strAgente: this.strAgenteSP,
      strTipo: this.strTipoAgente
    }).subscribe((data: any) => {

      this.arrayTotalLeads = data

      this.arrayTotalLeads.forEach((b: any) => {

        let fecha = b.strFechaActividad.split('/')
        let fechaStart = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
        if (fechaStart == this.strFechaEstimadaCierreInput && b.intTiempoTranscurridoDias == 0 && b.intTiempoTranscurridoHoras == 0) {
        } else {
          let datosCalendario = {
            title: b.strNombreEmpresa,
            start: fechaStart,
            description: b.strTipo,
            intIdLeads: b.intIdLeads,
            strFase: b.strFase
          }
          this.calendarioLeads.push(datosCalendario)
        }
      })

      let arrayAux = this.calendarioLeads.filter((b: any) => b.strFase === this.strTipo.toUpperCase())

      const calendarOptions: CalendarOptions = {
        initialView: 'dayGridMonth',
        plugins: [dayGridPlugin],
        locale: 'es', // Configura el idioma en español
        events: arrayAux, // Agrega el arreglo de eventos aquí
        eventClick: (arg) => {
        
          this.fnDetalleLead(arg.event.extendedProps['intIdLeads'])
        },
        eventDidMount: function (info) {
          const eventElement = info.el;
          
          eventElement.setAttribute('data-bs-toggle', 'modal'); // Habilita un tooltip
          eventElement.setAttribute('data-bs-placement', 'center');
          eventElement.setAttribute('data-bs-target', '#detalleLead');  // Posición del tooltip  data-bs-toggle="modal"
     
                                           
          eventElement.setAttribute('title', info.event.extendedProps['description']); // Establece el tooltip basado en la descripción
          // Puedes personalizar más la presentación aquí si es necesario
        },

      };

      this.calendarOptions = calendarOptions

      this.array_por_contactar = this.arrayTotalLeads.filter((b: any) => b.strEstatus == 'Por Contactar')
      this.dblMontoPorContactar = this.calcularMontoPorContactar();
      this.intTotal_por_contactar = this.array_por_contactar.length
      this.elementosPorPaginaPorContactar = this.array_por_contactar.length

      this.arrayPresentacion = this.arrayTotalLeads.filter((b: any) => b.strEstatus == 'Presentacion' || b.strEstatus == 'Presentación')
      this.dblMontoPresentacion = this.calcularMontoPresentacion();
      this.intTotal_presentacion = this.arrayPresentacion.length

      this.arrayRecorridoLead = this.arrayTotalLeads.filter((b: any) => b.strEstatus == 'Recorrido')
      this.dblMontoRecorridoLead = this.calcularMontoRecorridoLead();
      this.intTotal_recorrido_lead = this.arrayRecorridoLead.length

      this.arrayPerdidos = this.arrayTotalLeads.filter((b: any) => b.strEstatus == 'PERDIDO')
      this.dblMontoPerdidos = this.calcularMontoPerdidos();
      this.intTotal_Perdido = this.arrayPerdidos.length

      //Fase para prospecto----------------------------------------------------------------------------------
      this.arrayPropuesta = this.arrayTotalLeads.filter((b: any) => b.strEstatus == 'Propuesta Economica' && b.strFase == 'PROSPECTO')
      this.dblMontoPropuesta = this.calcularMontoPropuesta();
      this.intTotal_propuesta = this.arrayPropuesta.length

      this.arrayNegociacion = this.arrayTotalLeads.filter((b: any) => (b.strEstatus == 'Negociacion' || b.strEstatus == 'Negociación') && b.strFase == 'PROSPECTO')
      this.dblMontoNegociacion = this.calcularMontoNegociacion();
      this.intTotal_negociacion = this.arrayNegociacion.length

      this.arrayCierre = this.arrayTotalLeads.filter((b: any) => b.strEstatus == 'Cierre' && b.strFase == 'PROSPECTO')
      this.dblMontoCierre = this.calcularMontoCierre();
      this.intTotal_cierre = this.arrayCierre.length

      //Fases para cliente---------------------------------------------------------------------------------
      this.arrayPropuestaCliente = this.arrayTotalLeads.filter((b: any) => b.strEstatus == 'Propuesta Economica' && b.strFase == 'CLIENTE')
      this.dblMontoPropuestaCliente = this.calcularMontoPropuestaCliente();
      this.intTotal_propuesta_cliente = this.arrayPropuestaCliente.length

      this.arrayNegociacionCliente = this.arrayTotalLeads.filter((b: any) => (b.strEstatus == 'Negociacion' || b.strEstatus == 'Negociación') && b.strFase == 'CLIENTE')
      this.dblMontoNegociacionCliente = this.calcularMontoNegociacionCliente();
      this.intTotal_negociacion_cliente = this.arrayNegociacionCliente.length

      this.arrayCierreCliente = this.arrayTotalLeads.filter((b: any) => b.strEstatus == 'Cierre' && b.strFase == 'CLIENTE')



      this.dblMontoCierreCliente = this.calcularMontoCierreCliente();
      this.intTotal_cierre_cliente = this.arrayCierreCliente.length

      this.global = this.dblMontoPorContactar + this.dblMontoPresentacion + this.dblMontoRecorridoLead + this.dblMontoPropuesta + this.dblMontoNegociacion + this.dblMontoCierre

      this.arrayCierreCliente.sort((a: any, b: any) => {
        const fechaA = (a.strFechaInicioServicio) ? this.parseFecha2(a.strFechaInicioServicio) : this.parseFecha2('');
        const fechaB = (b.strFechaInicioServicio) ? this.parseFecha2(b.strFechaInicioServicio) : this.parseFecha2('');
        return fechaB.getTime() - fechaA.getTime();
      });
      this.aplicarFiltros();
    },
      error => {
        var error = <any>error;
        console.log(error);
      }
    )
  }
  parseFecha2(strFecha: string): Date {
    let partes: any
    let dia: any;
    let mes: any;
    let anio: any;
    let hora: any;
    let minutos: any;
    let segundos: any;
    if (strFecha != '') {
      partes = strFecha.split(/[\s/:]+/);
      dia = parseInt(partes[0], 10);
      mes = parseInt(partes[1], 10) - 1;
      anio = parseInt(partes[2], 10);
      hora = parseInt(partes[3], 10) + (partes[6] === 'p' ? 12 : 0);
      minutos = parseInt(partes[4], 10);
      segundos = parseInt(partes[5], 10);
    }

    return new Date(anio, mes, dia, hora, minutos, segundos);
  }

  /* fnUpdateLead() {
    
     let fecha = this.strFechaEstimadaCierre.split('-')
     this.strFechaEstimadaCierre = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
 
     this._serviciosService.sp_Leads({
       strAccion: 'UPDATE_DETALLE',
       intIdLeads: this.intIDLeads,
       strNoEmpleados: this.strNumeroEmpleados,
       strContactoTelefono: this.strTelefonoContacto,
       strContactoPuesto: this.strPuestoContacto,
       strContactoEmail: this.strEmailContacto,
       strNombreEmpresa: this.strNombreEmpresa,
       intID_Giro: Number(this.intGiro),
       strSector: this.strSector,
       strNombreContacto: this.strNombreContacto,
       strComentario: 'Prueba',
       strCodigoPostal: this.strCodigoPostal,
       strEstado: this.strEstado,
       strDelegacion: this.strDelegacion,
       strColonia: (this.strColonia != '') ? this.strColonia : this.strOtraColonia,
       strCalle: this.strCalle,
       intNoExterior: Number(this.strNumeroExterior),
       strEntreCalles: this.strEntreCalles,
       intLada: Number(this.strLadaEmpresa),
       intTelefono: Number(this.strTelefonoEmpresa),
       strRazonSocial: this.strRazonSocial,
       dblMonto: parseFloat(this.dblImporte),
       strRFC: this.strRFC,
       strMedioNosConocio: this.strMedioConocio,
       strFechaCierreEstimada: this.strFechaEstimadaCierre,
       intNoSucursales: Number(this.intTotalSucursales),
       strSitioWeb: this.strSitioWeb,
       strEstatus: this.strEtapa,
       strAgente: this.strAgente,
       strFase: this.strFase,
       strZona: this.strZona,
       strTipoCotizacion: this.strTipoCotizacion,
       intNumeroEmpleados: this.intCantidadElementos,
       xmlAnexos: this.arrayAnexosUpdate
     }).subscribe(
       result => {
 
         if (result.length > 0) {
           Swal.fire({
             position: 'center',
             icon: 'success',
             title: 'LEAD ACTUALIZADO',
             showConfirmButton: false,
             timer: 1500
           })
           this.SubirAnexos()
           this.fnListadoLeads()
 
           this.arrayAnexosUpdate = []
         } else {
         }
 
       },
       error => {
         var error = <any>error;
         console.log(error);
       }
     );
   }
 */
  fnUpdateLead_Nuevo() {

    if (this.strCodigoPostal && this.strEtapa == 'Recorrido') {

      let fecha = this.strFechaEstimadaCierre.split('-')
      this.strFechaEstimadaCierre = fecha[2] + '-' + fecha[1] + '-' + fecha[0]

      let arregloAux: any = []

      this.arrayContactosDetalle.forEach((b: any) => {
        let datos = {
          strNombreContacto: b.strNombreContacto,
          strContactoPuesto: b.strContactoPuesto,
          strContactoTelefono: b.strContactoTelefono,
          strContactoEmail: b.strContactoEmail
        }
        arregloAux.push(datos)
      })

      this._serviciosService.sp_Leads({
        strAccion: 'UPDATE_DETALLE_NUEVO',
        intIdLeads: this.intIDLeads,
        strNoEmpleados: this.strNumeroEmpleados,
        strNombreEmpresa: this.strNombreEmpresa,
        intID_Giro: Number(this.intGiro),
        strSector: this.strSector,
        strComentario: '',
        strCodigoPostal: this.strCodigoPostal,
        strEstado: this.strEstado,
        strDelegacion: this.strDelegacion,
        strColonia: (this.strColonia != '') ? this.strColonia : this.strOtraColonia,
        strCalle: this.strCalle,
        intNoExterior: Number(this.strNumeroExterior),
        strEntreCalles: this.strEntreCalles,
        intLada: Number(this.strLadaEmpresa),
        intTelefono: Number(this.strTelefonoEmpresa),
        strRazonSocial: this.strRazonSocial,
        dblMonto: parseFloat(this.dblImporte),
        strRFC: this.strRFC,
        strMedioNosConocio: this.strMedioConocio,
        strFechaCierreEstimada: this.strFechaEstimadaCierre,
        intNoSucursales: Number(this.intTotalSucursales),
        strSitioWeb: this.strSitioWeb,
        strEstatus: this.strEtapa,
        strAgente: this.strAgente,
        strFase: this.strFase,
        strZona: this.strZona,
        strTipoCotizacion: this.strTipoCotizacion,
        intNumeroEmpleados: this.intCantidadElementos,
        strRecomendado: this.strRecomendacion,
        xmlAnexos: this.arrayAnexosUpdate,
        xmlContactos: arregloAux,

      }).subscribe(
        result => {

          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'LEAD ACTUALIZADO',
            showConfirmButton: false,
            timer: 1500
          })

          this.SubirAnexos()
          this.fnListadoLeads()

          this.fnValidacion_Ubicacion()

          document.getElementById('boton')?.click();

          this.arrayAnexosUpdate = []
        },
        error => {
          var error = <any>error;
          console.log(error);
        }
      );


    } else if (this.strEtapa != 'Recorrido') {

      let fecha = this.strFechaEstimadaCierre.split('-')
      this.strFechaEstimadaCierre = fecha[2] + '-' + fecha[1] + '-' + fecha[0]

      let arregloAux: any = []

      this.arrayContactosDetalle.forEach((b: any) => {
        let datos = {
          strNombreContacto: b.strNombreContacto,
          strContactoPuesto: b.strContactoPuesto,
          strContactoTelefono: b.strContactoTelefono,
          strContactoEmail: b.strContactoEmail
        }
        arregloAux.push(datos)
      })

      this._serviciosService.sp_Leads({
        strAccion: 'UPDATE_DETALLE_NUEVO',
        intIdLeads: this.intIDLeads,
        strNoEmpleados: this.strNumeroEmpleados,
        strNombreEmpresa: this.strNombreEmpresa,
        intID_Giro: Number(this.intGiro),
        strSector: this.strSector,
        strComentario: '',
        strCodigoPostal: this.strCodigoPostal,
        strEstado: this.strEstado,
        strDelegacion: this.strDelegacion,
        strColonia: (this.strColonia != '') ? this.strColonia : this.strOtraColonia,
        strCalle: this.strCalle,
        intNoExterior: Number(this.strNumeroExterior),
        strEntreCalles: this.strEntreCalles,
        intLada: Number(this.strLadaEmpresa),
        intTelefono: Number(this.strTelefonoEmpresa),
        strRazonSocial: this.strRazonSocial,
        dblMonto: parseFloat(this.dblImporte),
        strRFC: this.strRFC,
        strMedioNosConocio: this.strMedioConocio,
        strFechaCierreEstimada: this.strFechaEstimadaCierre,
        intNoSucursales: Number(this.intTotalSucursales),
        strSitioWeb: this.strSitioWeb,
        strEstatus: this.strEtapa,
        strAgente: this.strAgente,
        strFase: this.strFase,
        strZona: this.strZona,
        strTipoCotizacion: this.strTipoCotizacion,
        intNumeroEmpleados: this.intCantidadElementos,
        strRecomendado: this.strRecomendacion,
        xmlAnexos: this.arrayAnexosUpdate,
        xmlContactos: arregloAux,

      }).subscribe(
        result => {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'LEAD ACTUALIZADO',
            showConfirmButton: false,
            timer: 1500
          })

          //$('#detalleLead').modal('hide');

          this.SubirAnexos()
          this.fnListadoLeads()

          this.arrayAnexosUpdate = []

          document.getElementById('boton')?.click();
        },
        error => {
          var error = <any>error;
          console.log(error);
        }
      );
    }
    else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: '¡Datos Faltantes, Favor de revisar datos fiscales y/o RFC!',
      })
    }

  }

  cambiarPrioridad(event: any) {
    if (event.target.value == '1-20 empleados') {
      this.strPrioridad = 'Baja'
    } else if (event.target.value == '21-50 empleados' || event.target.value == '51 - 300 empleados') {
      this.strPrioridad = 'Media'
    } else if (event.target.value == '3001 - 1000 empleados') {
      this.strPrioridad = 'Alta'
    } else if (event.target.value == '1001 - 2000 empleados' || event.target.value == '2001 + empleados') {
      this.strPrioridad = 'URGENTE'
    }
  }

  calcularMontoPorContactar(): number {
    return this.array_por_contactar.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }
  calcularMontoPresentacion(): number {
    return this.arrayPresentacion.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }
  calcularMontoRecorridoLead(): number {
    return this.arrayRecorridoLead.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }
  calcularMontoPerdidos(): number {
    return this.arrayPerdidos.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }

  calcularMontoPropuesta(): number {
    return this.arrayPropuesta.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }
  calcularMontoNegociacion(): number {
    return this.arrayNegociacion.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }
  calcularMontoCierre(): number {
    return this.arrayCierre.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }

  calcularMontoPropuestaCliente(): number {
    return this.arrayPropuestaCliente.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }
  calcularMontoNegociacionCliente(): number {
    return this.arrayNegociacionCliente.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }
  calcularMontoCierreCliente(): number {
    return this.arrayCierreCliente.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.dblMonto;
    }, 0);
  }

  fnTamanoEmpresa() {
    this._serviciosService.sp_Contactame({
      strAccion: 'TamanoEmpresa'
    }).subscribe(
      result => {

        this.arrayTamanoEmpresa = result
      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnGetActividades() {
    this._serviciosService.sp_Leads({
      strAccion: 'OBTENER_ACTIVIDADES',
      intIDLeads: this.intIDLeads
    }).subscribe(
      result => {
        if (result.length > 0) {

          this.arrayActividades = result
          this.arrayActividades.forEach((item: any) => {
            let campo = item.strFechaCierreEstimada.split(' ')
            // Asigna el nuevo valor al campo en el registro
            item.strFechaCierreEstimada = campo[0];
          });
        }
      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnZonas() {
    this._serviciosService.sp_Laborae({
      "strAccion": "LISTADO_ZONAS"
    }).subscribe(
      result => {
        this.arrayZonas = result
      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnObtenerHistorial() {
    this._serviciosService.sp_Leads({
      strAccion: "OBTENER_HISTORIAL",
      intIDLeads: this.intIDLeads
    }).subscribe(
      result => {
        this.ListadoHistorial = result.map((item: any) => ({ Fecha: item.strFechaCierreEstimada, Acción: item.strTipo, Observaciones: item.strComentario }));
        this.exportHistorialAsXLSX()
      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnGiros() {
    this._serviciosService.sp_Contactame({
      strAccion: 'Giros'
    }).subscribe(
      result => {
        this.arrayGiros = result
      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnGetAnexos() {
    this._serviciosService.sp_Leads({
      strAccion: 'OBTENER_ANEXOS',
      intIdLeads: this.intIDLeads
    }).subscribe(
      result => {

        this.arrayAnexos = result

      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnInsertActividades() {

    let fechaAux = (this.strFechaActividad) ? this.strFechaActividad : this.fechaInicioServicio

    let fechaF: any
    if (this.fechaInicioServicio) {
      fechaF = this.fechaInicioServicio
    } else {
      let fechaFormato = new Date(fechaAux)
      let dia = (fechaFormato.getDate() < 10) ? ('0' + fechaFormato.getDate()) : fechaFormato.getDate()
      let mes = (fechaFormato.getMonth() < 10) ? ('0' + (fechaFormato.getMonth() + 1)) : (fechaFormato.getMonth() + 1)
      let anio = fechaFormato.getFullYear()
      let hora = (fechaFormato.getHours() < 10) ? ('0' + fechaFormato.getHours()) : fechaFormato.getHours()
      let minutos = (fechaFormato.getMinutes() < 10) ? ('0' + fechaFormato.getMinutes()) : fechaFormato.getMinutes()
      let segundos = (fechaFormato.getSeconds() < 10) ? ('0' + fechaFormato.getSeconds()) : fechaFormato.getSeconds()
      fechaF = dia + '-' + (mes) + '-' + anio + ' ' + hora + ':' + minutos + ':' + segundos
    }

    this._serviciosService.sp_Leads({
      strAccion: 'Insert_Actividades',
      intIdLeads: this.intIDLeads,
      strAgente: this.strAgenteSP,
      strFechaCierreEstimada: fechaF,
      strTipo: this.strTipoActividad,
      strResultado: this.strResultado,
      strComentario: this.strComentario,
      strAsunto: '',
      strContenido: '',
      strEstatus: (this.fechaInicioServicio) ? 'CONCLUIDO' : 'PENDIENTE'
    }).subscribe(
      result => {

        var dropdownMenu = document.getElementById('dropInsert');
        dropdownMenu?.classList.remove('activo');
        this.fnGetActividadPendiente()
        this.fnGetActividades()
        this.fnListadoLeads()
      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnInsertActividadesSinF(event: Event) {

    let tipo = this.strActividadSimple.split(' ')

    let f = new Date()
    let fechaF = f.getDate() + '-' + (f.getMonth() + 1) + '-' + f.getFullYear() + ' ' + f.getHours() + ':' + f.getMinutes() + ':' + f.getSeconds()
    this._serviciosService.sp_Leads({
      strAccion: 'Insert_Actividades',
      intIdLeads: this.intIDLeads,
      strAgente: this.strAgenteSP,
      strFechaCierreEstimada: fechaF,
      strTipo: tipo[0], //this.strTipoActivida,
      strResultado: this.strDescripcionActividad,
      strComentario: this.strActividadSimple,
      strAsunto: '',
      strContenido: '',
      strEstatus: 'CONCLUIDO'
    }).subscribe(
      result => {

        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Actividad Registrada',
          showConfirmButton: false,
          timer: 1500
        })

        this.fnGetActividadPendiente()
        this.fnGetActividades()

        this.strActividadSimple = ''
        this.strDescripcionActividad = ''
      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnGetActividadPendiente() {
    this.intTiempoDias = 0
    this.intTiempoHoras = 0
    this._serviciosService.sp_Leads({
      strAccion: 'OBTENER_ACTIVIDAD_PENDIENTE',
      intIDLeads: this.intIDLeads
    }).subscribe(
      result => {

        if (result.length > 0) {
          this.intTiempoDias = result[0].intTiempoTranscurridoDias
          this.intTiempoHoras = result[0].intTiempoTranscurridoHoras
        }
      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnInsertFechaInicioServicio() {

    let nombreAgente = this.arrayAgentes.filter((b: any) => b.strAgente == this.strAgente)
    nombreAgente = nombreAgente[0].strAgenteNombre
    let envio = this.strNombreEmpresa + ',' + this.fechaInicioServicio + ',' + nombreAgente

    /*this.socket.emit('cambioFaseCliente', envio)*/

    this._serviciosService.sp_Leads({
      strAccion: 'Insert_FechaInicioServicio',
      intIDLeads: this.intIDLeads,
      strFechaInicioServicio: this.fechaInicioServicio
    }).subscribe(
      result => {

        if (result.length > 0) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Actualizado Correctamente',
            showConfirmButton: false,
            timer: 1500
          })

          //llamar funcion para insertar como actividad
          this.strTipoActividad = 'GANADO'
          this.strResultado = 'Se gano'
          this.strComentario = 'Se gano'
          this.fnInsertActividades()
          this.fnListadoLeads()
        }

      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnGetDatosFiscales() {
    this._serviciosService.getAllSATCP({
      strCodigoPostal: this.strCodigoPostal
    }).subscribe(
      result => {
        if (result.length > 0) {
          this.strEstado = result[0].strEstado
          this.strDelegacion = result[0].strDelegacion

          this.arrayColonias = result
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: '¡Codigo Postal Incorrecto!',
          })

          this.strEstado = ''
          this.strDelegacion = ''
          this.arrayColonias = []
        }

      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
  }

  fnEliminarLead() {
    Swal.fire({
      title: 'Eliminar',
      text: "Estas seguro(a) de eliminar?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar!'
    }).then((result) => {
      if (result.isConfirmed) {

        this._serviciosService.sp_Leads({
          strAccion: 'ELIMINAR_LEAD',
          intIDLeads: this.intIDLeads
        }).subscribe(
          result => {
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Eliminado Correctamente',
              showConfirmButton: false,
              timer: 1500
            })
            this.fnListadoLeads()

            document.getElementById('cerrarModal')?.click();
          },
          error => {
            var error = <any>error;
            console.log(error);
          }
        );
      }
    })

  }

  cambiarFechaInicioServicio(event: any) {
    let fecha = (event.target.value).split('-')
    this.fechaInicioServicio = fecha[2] + '-' + fecha[1] + '-' + fecha[0]

  }
  cambiarFechaPerdido(event: any) {
    let fecha = (event.target.value).split('-')
    this.strFechaPerdido = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
  }

  cambiarFechaCancelado(event: any) {
    let fecha = (event.target.value).split('-')
    this.strFechaCancelado = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
  }

  cambiarFecha(event: any) {
    let fecha = (event.target.value).split('-')
    this.strFechaEstimadaCierre = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
    this.strFechaEstimadaCierreInput = fecha[0] + '-' + fecha[1] + '-' + fecha[2]
  }

  cambiarFase(event: any) {

    if (event.target.value == 'Por Contactar' || (event.target.value == 'Presentación' || event.target.value == 'Presentacion') || event.target.value == 'Recorrido') {
      this.strFase = 'LEAD'
      this.banderaFase = true
    } else if (event.target.value == 'Propuesta Economica' || event.target.value == 'Negociación') {
      this.strFase = 'PROSPECTO'
      this.banderaFase = false
      this.banderaCierre = true
    }

    this.validarUbicacion()
  }

  exportHistorialAsXLSX(): void {
    this._serviciosService.exportAsExcelFile(this.ListadoHistorial, 'Listado_Historico');
  }

  validarTelefono(telefono: string): boolean {
    const pattern = /^\d{10}$/; // Expresión regular para un número de teléfono de 10 dígitos

    return pattern.test(telefono);
  }

  validarInputTelefono() {
    if (!this.validarTelefono(this.strTelefonoContacto)) {
      // El número de teléfono no es válido, realiza alguna acción (por ejemplo, mostrar un mensaje de error)
    } else {
      // El número de teléfono es válido, continúa con el flujo normal
    }
  }
  fnCambiarFuturo(event: any) {
    if (event.target.value == 'SI') {
      this.banderaFuturo = true
    } else {
      this.banderaFuturo = false
    }
  }

  fnCancelado_Perdido() {

    let fecha = (this.strFechaPerdido) ? this.strFechaPerdido : this.strFechaCancelado
    let date = new Date()

    let fechaFormato = new Date(fecha)
    let dia = (fechaFormato.getDate() < 10) ? ('0' + fechaFormato.getDate()) : fechaFormato.getDate()
    let mes = (fechaFormato.getMonth() < 10) ? ('0' + (fechaFormato.getMonth() + 1)) : (fechaFormato.getMonth() + 1)
    let anio = fechaFormato.getFullYear()
    let hora = (fechaFormato.getHours() < 10) ? ('0' + fechaFormato.getHours()) : fechaFormato.getHours()
    let minutos = (fechaFormato.getMinutes() < 10) ? ('0' + fechaFormato.getMinutes()) : fechaFormato.getMinutes()
    let segundos = (fechaFormato.getSeconds() < 10) ? ('0' + fechaFormato.getSeconds()) : fechaFormato.getSeconds()
    let fechaF = dia + '-' + (mes) + '-' + anio + ' ' + hora + ':' + minutos + ':' + segundos
    let fechaAmano = date.getDate() + '/' + (date.getMonth()) + '/' + date.getFullYear()
    let nombreAgente = this.arrayAgentes.filter((b: any) => b.strAgente == this.strAgente)
    nombreAgente = nombreAgente[0].strAgenteNombre
    let envio = this.strNombreEmpresa + ',' + fechaAmano + ',' + nombreAgente

    /* if (this.strFechaPerdido) {
       this.socket.emit('perdido', envio)
     } else {
       this.socket.emit('cancelado', envio)
     }*/



    this._serviciosService.sp_Leads({
      strAccion: 'Update_Cancelado',
      intIdLeads: this.intIDLeads,
      strAgente: this.strAgenteSP,
      strFechaCierreEstimada: fechaF,
      strResultado: (this.strMotivoCancelado) ? this.strMotivoCancelado : this.strMotivoPerdido,
      strComentario: (this.strComentarioCancelado) ? this.strComentarioCancelado : this.strComentarioPerdido,
      strEstatus: (this.strFechaPerdido) ? 'PERDIDO' : 'CANCELADO',
    }).subscribe(
      result => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Registro Correcto',
          showConfirmButton: false,
          timer: 1500
        })
        this.fnListadoLeads()
      },
      error => {
        var error = <any>error;
        console.log(error);
      }
    );
    this.strFechaPerdido = undefined
    this.strFechaCancelado = undefined
  }
  validarCampos(item: any) {
    let aux = item.strNombreContacto !== '' || item.strContactoPuesto !== '' || item.strContactoTelefono !== ''
    //let aux = (this.strNombreContacto == '' || this.strPuestoContacto == '' || this.strTelefonoContacto == '') && this.strEmailContacto;
    if (aux) {
      item.emailEsObligatorio = true
      this.banderaContacto = true
    } else {
      item.emailEsObligatorio = false
      this.banderaContacto = false
    }
  }
  /*
    validarCampos() {
      this.emailEsObligatorio = this.arrayContactosDetalle.some(
        (item:any) => item.strNombreContacto !== '' || item.strContactoPuesto !== '' || item.strContactoTelefono !== ''
      );
        
      this.guardarHabilitado = this.arrayContactosDetalle.every((item:any) =>
        item.strNombreContacto.trim() !== '' &&
        item.strContactoPuesto.trim() !== '' &&
        item.strContactoTelefono.trim() !== '' &&
        this.validarEmail(item.strContactoEmail)
      );
    }
  */
  validarEmailContacto(item: any) {
    if ((item.strNombreContacto !== '' || item.strContactoPuesto !== '' || item.strContactoTelefono !== '') && item.strContactoEmail != '') {
      item.emailEsObligatorio = true
      this.banderaContacto = true
      if (item.emailEsObligatorio && this.validarEmail(item.strContactoEmail)) {
        item.emailEsObligatorio = false
        this.banderaContacto = false
      }
    }
  }



  validarEmail(email: string): boolean {
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    return regex.test(email);
  }

  // Evento para actualizar los checkboxes sin desactivar los demás
  onCheckboxChange(checkboxName: string) {
    // Deseleccionar todos los checkboxes
    Object.keys(this.checkboxes).forEach((name) => {
      if (name !== checkboxName) {
        this.checkboxes[name] = false;
      }
    });

    // Cambiar el estado del checkbox seleccionado
    this.checkboxes[checkboxName] = !this.checkboxes[checkboxName];

    // Aplicar los filtros con el estado actual de los checkboxes
    this.aplicarFiltros();
  }


  // Función para aplicar los filtros según el estado de los checkboxes
  aplicarFiltros() {
    // Lógica para aplicar los filtros
    this.datosFiltradosContactar = this.array_por_contactar.filter((dato: any) => {
      const fecha = this.parseFecha(dato.strFechaActividad); // Asume que tienes una propiedad de fecha en tus datos
      const hoy = new Date();
      const manana = new Date(hoy);
      manana.setDate(manana.getDate() + 1);
      return (
        (!this.checkboxes.hoy || this.esMismaFecha(fecha, hoy)) &&
        (!this.checkboxes.manana || this.esMismaFecha(fecha, manana)) &&
        (!this.checkboxes.estaSemana || this.estasEnLaSemana(fecha, hoy)) &&
        (!this.checkboxes.esteMes || this.estasEnElMes(fecha, hoy)) &&
        (!this.checkboxes.futuros || this.esFuturo(fecha, hoy)) &&
        (!this.checkboxes.conDemora || this.esDemora(fecha, hoy))
      );
    });
    this.datosFiltradosPresentacion = this.arrayPresentacion.filter((dato: any) => {
      const fecha = this.parseFecha(dato.strFechaActividad); // Asume que tienes una propiedad de fecha en tus datos
      const hoy = new Date();
      const manana = new Date(hoy);
      manana.setDate(manana.getDate() + 1);
      return (
        (!this.checkboxes.hoy || this.esMismaFecha(fecha, hoy)) &&
        (!this.checkboxes.manana || this.esMismaFecha(fecha, manana)) &&
        (!this.checkboxes.estaSemana || this.estasEnLaSemana(fecha, hoy)) &&
        (!this.checkboxes.esteMes || this.estasEnElMes(fecha, hoy)) &&
        (!this.checkboxes.futuros || this.esFuturo(fecha, hoy)) &&
        (!this.checkboxes.conDemora || this.esDemora(fecha, hoy))
      );
    });
    this.datosFiltradosRecorrido = this.arrayRecorridoLead.filter((dato: any) => {
      const fecha = this.parseFecha(dato.strFechaActividad); // Asume que tienes una propiedad de fecha en tus datos
      const hoy = new Date();
      const manana = new Date(hoy);
      manana.setDate(manana.getDate() + 1);
      return (
        (!this.checkboxes.hoy || this.esMismaFecha(fecha, hoy)) &&
        (!this.checkboxes.manana || this.esMismaFecha(fecha, manana)) &&
        (!this.checkboxes.estaSemana || this.estasEnLaSemana(fecha, hoy)) &&
        (!this.checkboxes.esteMes || this.estasEnElMes(fecha, hoy)) &&
        (!this.checkboxes.futuros || this.esFuturo(fecha, hoy)) &&
        (!this.checkboxes.conDemora || this.esDemora(fecha, hoy))
      );
    });
    this.datosFiltradosPropuesta = this.arrayPropuesta.filter((dato: any) => {
      const fecha = this.parseFecha(dato.strFechaActividad); // Asume que tienes una propiedad de fecha en tus datos
      const hoy = new Date();
      const manana = new Date(hoy);
      manana.setDate(manana.getDate() + 1);
      return (
        (!this.checkboxes.hoy || this.esMismaFecha(fecha, hoy)) &&
        (!this.checkboxes.manana || this.esMismaFecha(fecha, manana)) &&
        (!this.checkboxes.estaSemana || this.estasEnLaSemana(fecha, hoy)) &&
        (!this.checkboxes.esteMes || this.estasEnElMes(fecha, hoy)) &&
        (!this.checkboxes.futuros || this.esFuturo(fecha, hoy)) &&
        (!this.checkboxes.conDemora || this.esDemora(fecha, hoy))
      );
    });
    this.datosFiltradosNegociacion = this.arrayNegociacion.filter((dato: any) => {
      const fecha = this.parseFecha(dato.strFechaActividad); // Asume que tienes una propiedad de fecha en tus datos
      const hoy = new Date();
      const manana = new Date(hoy);
      manana.setDate(manana.getDate() + 1);
      return (
        (!this.checkboxes.hoy || this.esMismaFecha(fecha, hoy)) &&
        (!this.checkboxes.manana || this.esMismaFecha(fecha, manana)) &&
        (!this.checkboxes.estaSemana || this.estasEnLaSemana(fecha, hoy)) &&
        (!this.checkboxes.esteMes || this.estasEnElMes(fecha, hoy)) &&
        (!this.checkboxes.futuros || this.esFuturo(fecha, hoy)) &&
        (!this.checkboxes.conDemora || this.esDemora(fecha, hoy))
      );
    });
    this.datosFiltradosCierre = this.arrayCierre.filter((dato: any) => {
      const fecha = this.parseFecha(dato.strFechaActividad); // Asume que tienes una propiedad de fecha en tus datos
      const hoy = new Date();
      const manana = new Date(hoy);
      manana.setDate(manana.getDate() + 1);
      return (
        (!this.checkboxes.hoy || this.esMismaFecha(fecha, hoy)) &&
        (!this.checkboxes.manana || this.esMismaFecha(fecha, manana)) &&
        (!this.checkboxes.estaSemana || this.estasEnLaSemana(fecha, hoy)) &&
        (!this.checkboxes.esteMes || this.estasEnElMes(fecha, hoy)) &&
        (!this.checkboxes.futuros || this.esFuturo(fecha, hoy)) &&
        (!this.checkboxes.conDemora || this.esDemora(fecha, hoy))
      );
    });
    this.datosFiltradosPropuestaCliente = this.arrayPropuestaCliente.filter((dato: any) => {
      const fecha = this.parseFecha(dato.strFechaActividad); // Asume que tienes una propiedad de fecha en tus datos
      const hoy = new Date();
      const manana = new Date(hoy);
      manana.setDate(manana.getDate() + 1);
      return (
        (!this.checkboxes.hoy || this.esMismaFecha(fecha, hoy)) &&
        (!this.checkboxes.manana || this.esMismaFecha(fecha, manana)) &&
        (!this.checkboxes.estaSemana || this.estasEnLaSemana(fecha, hoy)) &&
        (!this.checkboxes.esteMes || this.estasEnElMes(fecha, hoy)) &&
        (!this.checkboxes.futuros || this.esFuturo(fecha, hoy)) &&
        (!this.checkboxes.conDemora || this.esDemora(fecha, hoy))
      );
    });
    this.datosFiltradosNegociacionCliente = this.arrayNegociacionCliente.filter((dato: any) => {
      const fecha = this.parseFecha(dato.strFechaActividad); // Asume que tienes una propiedad de fecha en tus datos
      const hoy = new Date();
      const manana = new Date(hoy);
      manana.setDate(manana.getDate() + 1);
      return (
        (!this.checkboxes.hoy || this.esMismaFecha(fecha, hoy)) &&
        (!this.checkboxes.manana || this.esMismaFecha(fecha, manana)) &&
        (!this.checkboxes.estaSemana || this.estasEnLaSemana(fecha, hoy)) &&
        (!this.checkboxes.esteMes || this.estasEnElMes(fecha, hoy)) &&
        (!this.checkboxes.futuros || this.esFuturo(fecha, hoy)) &&
        (!this.checkboxes.conDemora || this.esDemora(fecha, hoy))
      );
    });
    this.datosFiltradosCierreCliente = this.arrayCierreCliente.filter((dato: any) => {
      const fecha = this.parseFecha(dato.strFechaActividad); // Asume que tienes una propiedad de fecha en tus datos
      const hoy = new Date();
      const manana = new Date(hoy);
      manana.setDate(manana.getDate() + 1);
      return (
        (!this.checkboxes.hoy || this.esMismaFecha(fecha, hoy)) &&
        (!this.checkboxes.manana || this.esMismaFecha(fecha, manana)) &&
        (!this.checkboxes.estaSemana || this.estasEnLaSemana(fecha, hoy)) &&
        (!this.checkboxes.esteMes || this.estasEnElMes(fecha, hoy)) &&
        (!this.checkboxes.futuros || this.esFuturo(fecha, hoy)) &&
        (!this.checkboxes.conDemora || this.esDemora(fecha, hoy))
      );
    });

  }

  // Función auxiliar para comparar fechas sin tener en cuenta la hora
  esMismaFecha(fecha1: Date, fecha2: Date): boolean {
    return (
      fecha1.getDate() === fecha2.getDate() &&
      fecha1.getMonth() === fecha2.getMonth() &&
      fecha1.getFullYear() === fecha2.getFullYear()
    );
  }

  // Función auxiliar para verificar si la fecha está dentro de la misma semana
  estasEnLaSemana(fecha: Date, hoy: Date): boolean {
    const inicioSemana = new Date(hoy);
    inicioSemana.setDate(inicioSemana.getDate() - hoy.getDay());
    const finSemana = new Date(inicioSemana);
    finSemana.setDate(finSemana.getDate() + 6);
    return fecha >= inicioSemana && fecha <= finSemana;
  }

  // Función auxiliar para verificar si la fecha está dentro del mismo mes
  estasEnElMes(fecha: Date, hoy: Date): boolean {
    return (
      fecha.getMonth() === hoy.getMonth() &&
      fecha.getFullYear() === hoy.getFullYear()
    );
  }

  // Función auxiliar para verificar si la fecha es un día futuro
  esFuturo(fecha: Date, hoy: Date): boolean {
    return fecha > hoy;
  }

  restarUnDia(fecha: Date): Date {
    const unDia = 24 * 60 * 60 * 1000; // Cantidad de milisegundos en un día
    const fechaRestada = new Date(fecha.getTime() - unDia); // Resta un día a la fecha
    return fechaRestada;
  }

  // Función auxiliar para verificar si la fecha es con demora
  esDemora(fecha: Date, hoy: Date): boolean {
    hoy = this.restarUnDia(hoy); // Resta un día a la variable 'hoy'

    return fecha < hoy;
  }

  // Función auxiliar para parsear la fecha en formato "dd/MM/yyyy"
  parseFecha(fechaStr: string): Date {
    const partes = fechaStr.split('/');
    const dia = Number(partes[0]);
    const mes = Number(partes[1]) - 1;
    const anio = Number(partes[2]);
    return new Date(anio, mes, dia);
  }

  fnEliminarContacto(index: any) {
    this.arrayContactosDetalle.splice(index, 1)
  }

  fnAgregarContacto() {
    this.arrayContactosDetalle.push({
      strNombreContacto: '',
      strContactoPuesto: '',
      strContactoTelefono: '',
      strContactoEmail: '',
      emailEsObligatorio: false
    })
  }

  fnEnviarEdificios() {

    this.router.navigate(['/coordinadores/Edificios', this.intIDCliente, this.intIDUbicacion, this.strNombreEmpresa]);
  }

  cambiarVista(vista: any) {
    this.activeButton = vista
    if (vista == 'cards') {
      this.banderaCards = true
      this.banderaLista = false
      this.banderaCalendario = false
    } else if (vista == 'lista') {
      this.banderaCards = false
      this.banderaLista = true
      this.banderaCalendario = false
    } else {
      this.banderaCards = false
      this.banderaLista = false
      this.banderaCalendario = true
    }
  }
}
